import { FullScreenError } from '@moniebook-web/components/molecules/full-screen-error';
import { getTokenVariable, PAGES } from '@register-ui/utils';
import { Navigate } from 'react-router-dom';

export function Unauthorized() {
    const loggedIn = getTokenVariable();

    return loggedIn ? (
        <FullScreenError
            showLogo={false}
            title="You can't access this page"
            message='The administrator has restricted your access to the content on this page, you can request access or navigate back to home.'
            actionText='Back to home'
            actionLink='/'
        />
    ) : (
        <Navigate to={PAGES.ONBOARDING.LANDING} />
    );
}
